// Parshva S - 15/11/2023 BT-102679 - Breeze- Multi Leg order entry - start
import { memo, useEffect, useState, useCallback, forwardRef, useImperativeHandle, useRef } from 'react';
import { BzButton, BzInputText, BzToggleButton, BzDropdown } from '../../../components';
import { Row, Col, Container, Button, Dropdown } from 'react-bootstrap';
import {
    WATCHLIST_GRID_INDEX, TL_INDEX, SUPPORT_RESISTANCE_VIEW, SCRIP_INSTRUMENTS, ORDER_TYPES,
    APP_INFO_PARAMS, ORDER_ENTRY_TYPES, MULTI_LEG, LAYOUT_TYPE, MARKET_SEGMENT_ID, DISPLAY_EXCHANGE_NAME,
    SURV_MEASURE_POPUP_ACTION,
    OPTION_CHAIN,
    SIDE_TRAY_EXPAND_PERCENTAGE,
    EXCHANGE_NAME_LIVEPULSE,
    MSG_MASTER
} from "../../../utils/global_variables";
import { useDispatch, useSelector } from 'react-redux';
import { setCautionaryMessageFromPopup, getExchangeWiseScripInfo, getMultiLegData, getMultiScriptSecongLeg, getMultiScriptSecongLegSuccess, updateMultiLegOrderConfirmed, getScripOrderInfo } from '../../../redux/actions/orders';
import { sendTouchlineRequest } from '../../../apis/web_socket';
import { handleModal, handleModalData } from '../../../redux/actions/modals';
import { useWFHMessages } from '../../../hooks';
import AddLegMultiscriptModal from "./AddLegMultiscriptModal";
import moment from "moment";
import SupportResistance from '../../Analysis/SupportResistance';
import AllExchangesMarketDepth from '../../AllExchangesMarketDepth';
import {
    calculateSupportRestistanceValues, getGSMGradeDescriptionFromScrip, validateLTPPriceBand, getAppInfoData,
    getLegObject, convertTouclineIndexToWatchlistGridIndex, handleBlink, deepClone
} from "../../../utils/global_functions";
import { getWfhTouchlineLastTick } from '../../../redux/actions/wfh';
import { InlineScripSeach } from '../../Search';
import { toastConfig } from '../../../redux/actions/toast';
import BrokerageModalMultiLeg from './BrokerageModalMultiLeg';
import { _getExpiryForScrip } from '../../../controllers/orders';
import { LoginLoader } from '../../Login';
import LtpPriceBandValidationInfoModal from './LtpPriceBandValidationInfoModal';
import { setScripOverviewData } from '../../../redux/actions/marketOverview';
import { updateScripAndOptionData } from '../../../redux/actions/optionChain';
//PrachiTawde : 05-05-2023 : BT-106776 -  Breeze - Display Brokerage and statutory charges - End

//PrachiTawde : 05-05-2023 : BT-106776 -  Breeze - Display Brokerage and statutory charges - Start
const objDropdownOptions = {

    heading: ["BUY/SELL", "SYMBOL", "EXPIRY", "STRIKE PRICE", "OPT. TYPE", "ORDER TYPE", "LOTS", "PRICE", "VALIDITY", ""]
};

// Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - Start
const objSelectOrderOptionInit = {
    frequency: "MONTHLY",
    every: "First",
    day_date: "Day",
    day: "Monday",
    everyForWeekly: "MONDAY",
    productType: "MARGIN",
    productTypeDesc: '',
    validityTypes: "DAY",
    orderType: ORDER_ENTRY_TYPES.RL,
    orderBy: 'Quantity',
    isAmo: false,
    selectSpecificFrequencyDate: 0,
    isDefaultProductType: true
};
// Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - End
const MultiLeg = forwardRef(({ layoutType, activeButtonToggleIndex, setIsExpanded }, ref) => {
    const orderInfo = useSelector(state => state.orders?.scripOrderInfo?.scripData);
    const currentDate = new Date().toLocaleDateString("en-CA").split("/").reverse().join('-');
    // Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - Start
    const [orderInputs, setOrderInputs] = useState({ scripQuantity: 1, scripLot: 1, scripAmount: 0, scripPrice: '', slTrigger: 0, quantity: 0, capPrice: 0, numberOfInstallment: 0, intradayTrigger: 0, intradayLimit: 0, intradayTrailing: 0, intradayProfit: 0, discQty: 0, startDate: currentDate, gtdDate: currentDate });
    const isOrderConfirmed = useSelector(state => state.orders.isMultiLegOrderConfirmed);
    const [selectOrderOption, setSelectOrderOption] = useState(objSelectOrderOptionInit);
    const ltpPriceBandMaster = useSelector(state => state.orders.ltpPriceBandMaster);
    // Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - End
    const dispatch = useDispatch();
    const [isLoader, setIsLoader] = useState(false);
    // const arrFutureTabData = useSelector(state => state.marketOverview?.arrFutureTabData)
    const multiLegData = useSelector(state => state.orders.multiLegData);
    const [legInfo, setLegInfo] = useState([]);
    const multiScriptSecondLeg = useSelector(state => state.orders.multiScriptSecondLeg);
    const whatsHotData = useSelector(state => state.dontMiss.whatsHotData);
    const appInfo = useSelector(state => state?.appInfo?.appInfo);
    const [isShowMarketDepth, setIsShowMarketDepth] = useState(null);
    const [scripInfo, setScripInfo] = useState(null);
    const [marketDepthActiveTab, setMarketDepthActiveTab] = useState('MarketDepth');
    const [supportResistance, setSupportResistance] = useState({});
    const [editKey, setEditKey] = useState(-1);
    const [showSearchBar, setShowSearchBar] = useState(false);
    const [multiLegAllowed, setMultiLegAllowed] = useState(true);
    const [brokerageData, setShowBrokerage] = useState({});
    const [selectedLegToUpdate, setSelectedLegToUpdate] = useState(null);
    const [touchlineFlag, setTouchlineFlag] = useState(false);
    const FirstLegExpDate = moment(scripInfo?.[WATCHLIST_GRID_INDEX.EXPIRYDATE]).format('YYYY-MM-DD');

    const modals = useSelector(state => state?.modals?.modals);// AJitesh 30-07-2024 get modal data to check if reorder mode

    const [legDataForChildComps, setLegDataForChildComps] = useState([]); // abc Ajitesh 19-07-2024 Copy of legInfo but not rerendered constantly to be passed to lower level
    const [runOnce, setRunOnce] = useState(false); // Ajitesh 23-07 state var to be added to main variable to prevent resetting multi leg modal on repeated whatshotdata call
    const [legsThatFailLtpPriceValidation, setLegsThatFailLtpPriceValidation] = useState([]);
    const [expiryListFromApi, setExpiryListFromApi] = useState([]);
    const inlineSearchRef = useRef();


    useEffect(() => {
        if (multiLegData?.length > 0) {
            setLegDataForChildComps(multiLegData);
            setLegInfo(multiLegData);
        }
    }, [multiLegData]);

    useEffect(() => {
        if (multiLegData?.length === 0 && legInfo?.length > 0) {
            dispatch(getMultiLegData(legInfo));
        }
    }, [multiLegData, legInfo, dispatch]);



    const getActiveButtonToggleIndex = (ind) => {
        return ind === 0 ? 1 : 0;
    };

    const handleDropdownChange = (e, i, options = {}) => {
        const { value, name } = e.target;
        setLegInfo(prev => {
            let temp = [...prev];
            switch (name) {
                case "activeButtonToggleIndex":
                    temp[i][name] = value === 'BUY' ? 0 : 1;
                    break;
                case "expiryDate":
                    let eDate = '';
                    let obj = legInfo.find(el => moment(el.expiryDate).format('DDMMMYYYY').toUpperCase() === value);
                    if (!obj?.instrument?.startsWith("OPT") && legInfo.findIndex(el => el.token === obj?.selectedExpiry.nToken) !== -1) {
                        eDate = prev[i].expiryDate;
                    } else {
                        eDate = moment(value, 'DDMMMYYYY').format("YYYY-MM-DD");
                        let data = options?.element?.expiryList?.find(el => el.nExpiryDate1 === value);
                        sendTouchlineRequest([{ exchangeId: data?.nAssetMktId, token: data?.nToken, isSubscribe: true }]);
                        temp[i] = {
                            ...temp[i],
                            changeInLtp: 0,
                            ltpPercent: 0,
                            legPrice: "0.00",
                            token: data?.nToken,
                            selectedExpiry: data,
                            strikeprice: data?.nStrikePrice ? (data?.nStrikePrice / data?.nPriceBdAttribute)?.toFixed(scripInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) : "NA",
                            optiontype: data?.sOptionType ? data?.sOptionType : "NA"
                        };
                    }

                    // DONT DELETE!!
                    // if (legInfo.find(el => moment(el.expiryDate).format('DDMMMYYYY').toUpperCase() === value)) {
                    //     eDate = prev[i].expiryDate;
                    // } else {
                    //     eDate = moment(value, 'DDMMMYYYY').format("YYYY-MM-DD");
                    //     let data = options?.list?.find(el => el.nExpiryDate1 === value);
                    //     sendTouchlineRequest([{ exchangeId: data?.nAssetMktId, token: data?.nToken, isSubscribe: true }]);
                    //     temp[i] = {
                    //         ...temp[i],
                    //         changeInLtp: 0,
                    //         ltpPercent: 0,
                    //         legPrice: "0.00",
                    //         token: data?.nToken,
                    //     };

                    temp[i]['expiryDate'] = eDate;
                    break;
                case "orderType":
                    temp[i][name] = value;
                    temp[i]['legPrice'] = legInfo[i]?.ltp;
                    break;
                case "optiontype":
                    temp[i][name] = value;
                    break;
                default:
                    break;
            }
            return temp;
        });
    };

    const handleChange = (e, name, i) => {

        const { value } = e.target;
        // To remove any decimals as soon as user types in qty/lot field
        let valueWithoutDecimals = name === "count" ? value.replace(/\./g, '') : value;
        if (isNaN(valueWithoutDecimals) && valueWithoutDecimals?.toString() !== '-') {
            setLegInfo(prev => {
                let temp = [...prev];
                temp[i][name] = 0;
                return temp;
            });
        } else {
            setLegInfo(prev => {
                let temp = [...prev];
                temp[i][name] = valueWithoutDecimals;
                return temp;
            });
        }
    };

    const handleBlur = (e, name, i) => {
        let { value } = e.target;
        setLegInfo(prev => {
            let temp = [...prev];
            switch (name) {
                case "count":
                    if (!value || value <= 0) {
                        value = 1;
                    } else if (value) {
                        value = Math.round(value);
                    }
                    break;
                case "legPrice":

                    if (!value) {
                        value = 0;
                    } else if (value) {
                        //value = parsseFloat(value)?.toFixed(scripInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                        value = Math.abs(value);
                    }
                    value = parseFloat(value)?.toFixed(scripInfo ? scripInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] : orderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    break;
                default: break;
            }
            temp[i][name] = value;
            return temp;
        });
    };

    // Function to handle when user updates an existing leg
    const updateLegHandler = (selectedScrip) => {
        let temp = [...legInfo];
        // Ajitesh 24-07-2024 Send subscription request request for updated new scrip
        sendTouchlineRequest([{ exchangeId: selectedScrip?.[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: selectedScrip?.[WATCHLIST_GRID_INDEX.TOKEN] }]);
        // Ajitesh 24-07-2024 Wait for subscription data to be saved and then execute to get all updated ltp and other values
        setTimeout(() => {
            let info = dispatch(getWfhTouchlineLastTick());
            if (selectedScrip?.source === "legSearchUpdate") {
                temp[selectedScrip?.legNumber] = getLegObject({
                    info: Object.values(selectedScrip), // To get correct LTP from search when users updated currecny or commodity leg
                    // Ajitesh 12-09-2024 Adds conditions to below 4 properties to take data from touchline or show 0s with proper digits after decimal
                    legPrice: info[`${selectedScrip?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${selectedScrip?.[WATCHLIST_GRID_INDEX.TOKEN]}`] ? info[`${selectedScrip?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${selectedScrip?.[WATCHLIST_GRID_INDEX.TOKEN]}`]?.[TL_INDEX.LAST_TRADE_PRICE] : parseFloat("0").toFixed(selectedScrip[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]),
                    ltp: info[`${selectedScrip?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${selectedScrip?.[WATCHLIST_GRID_INDEX.TOKEN]}`] ? info[`${selectedScrip?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${selectedScrip?.[WATCHLIST_GRID_INDEX.TOKEN]}`]?.[TL_INDEX.LAST_TRADE_PRICE] : parseFloat("0").toFixed(selectedScrip[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]),
                    changeInLtp: info[`${selectedScrip?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${selectedScrip?.[WATCHLIST_GRID_INDEX.TOKEN]}`] ? info[`${selectedScrip?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${selectedScrip?.[WATCHLIST_GRID_INDEX.TOKEN]}`]?.[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] : parseFloat("0").toFixed(selectedScrip[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]),
                    ltpPercent: info[`${selectedScrip?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${selectedScrip?.[WATCHLIST_GRID_INDEX.TOKEN]}`] ? info[`${selectedScrip?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${selectedScrip?.[WATCHLIST_GRID_INDEX.TOKEN]}`]?.[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE] : parseFloat("0").toFixed(2),
                    symbol: selectedScrip?.[WATCHLIST_GRID_INDEX.SYMBOL],
                    // Ajitesh 25-09-2024 adds below two properties to show proper lot size and price tick validation when currency or commodity leg are updated
                    ask_qty: selectedScrip?.[WATCHLIST_GRID_INDEX.REGULAR_LOT],
                    priceTick: selectedScrip?.[WATCHLIST_GRID_INDEX.PRICE_TICK],
                    activeButtonToggleIndex: temp[selectedScrip?.legNumber]?.activeButtonToggleIndex,
                    expiryDate: moment(selectedScrip?.[WATCHLIST_GRID_INDEX.EXPIRYDATE]).format('YYYY-MM-DD'),
                    exchange: selectedScrip[WATCHLIST_GRID_INDEX?.EXCHANGE_SEGMENT],
                    expiryList: [...expiryListFromApi],
                    selectedExpiry: expiryListFromApi.find(el => el.nExpiryDate1 === selectedScrip?.[WATCHLIST_GRID_INDEX?.EXPIRYDATE]),
                    decLoc: selectedScrip?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
                    decimalLocatorLength: selectedScrip?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] // Ajitesh 16-07-2024 Adds decimal locator length field as extraInfo arr of 116 scripinfo fields not received frmo futures tab
                }, WATCHLIST_GRID_INDEX, selectedScrip?.legNumber + 1);
                // Only updates redux which will trigger an update to state variable when user updates a currency or commodity leg
                dispatch(getMultiLegData(temp));
            } else if (selectedScrip?.source === "legUpdate") {
                temp[selectedScrip?.legNumber] = {
                    ...temp[selectedScrip?.legNumber],
                    ...selectedScrip,
                    legNumber: selectedScrip?.legNumber + 1, // Increment leg number as while spreading we take array index and hence incorrect legnumber is assigned
                    activeButtonToggleIndex: selectedScrip?.type,
                    strikeprice: selectedScrip?.strikeprice ? selectedScrip?.strikeprice : "NA", // Ajitesh 22-07 Add NA if user replaces options scrip with Futures from search icon
                    optiontype: selectedScrip?.optiontype ? selectedScrip?.optiontype : "NA", // Ajitesh 22-07 Add NA if user replaces options scrip with Futures from search icon
                    instrument: SCRIP_INSTRUMENTS.FUTSTK, // Ajitesh 29-07-2024 Adds FUTSTK when user clicks on B/S btns from Futures screen to show correct data in option chain screen in toast
                    legPrice: selectedScrip?.tlData?.[TL_INDEX.LAST_TRADE_PRICE],
                    ltpPercent: selectedScrip?.tlData?.[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
                    changeInLtp: selectedScrip?.tlData?.[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE],
                    decimalLocatorLength: selectedScrip?.extraInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH], // Ajitesh 16-07-2024 Adds decimal locator length field as extraInfo arr of 116 scripinfo fields not received frmo futures tab
                    exchange: selectedScrip?.tlData?.[TL_INDEX.EXCHANGE]
                };
                // Only updates redux which will trigger an update to state variable when user updates a derivative leg
                dispatch(getMultiLegData(temp));
            }
        }, 300);
        dispatch(handleModal([{ "ADD_LEG_MODAL": false }]));
    };

    // Ajitesh 30-09-2024 Adds extra instrument arg to get correct instrument for leg to get api call
    const onhandleMarketDepth = useCallback((arrActiveScripInformation, i, instrument) => {
        // Ajitesh 30-09-2024 Manipulating instrument inside extra info of selected leg in case user adds a FUT leg with OPT legs or vice versa
        arrActiveScripInformation[WATCHLIST_GRID_INDEX.INSTRUMENT] = instrument;
        setTimeout(() => {
            setIsShowMarketDepth((prev) => {
                if (prev === i) {
                    return null;
                }
                else {
                    // Api call to get scrip information for market depth
                    dispatch(getExchangeWiseScripInfo(arrActiveScripInformation));
                    return i;
                }
            });
        }, 100);
        if (arrActiveScripInformation?.length !== 0) {
            const resitancePivotObj = calculateSupportRestistanceValues(arrActiveScripInformation, 'Classic', '(H+L+C)/3', scripInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
            setSupportResistance(resitancePivotObj);
        } else { }
    }, [scripInfo, dispatch]);
    const onHandleClick = useCallback((name, index, e = null) => {
        if (name.startsWith('qty')) {
            if (e && e.key === 'ArrowUp') {
                e.preventDefault();
                name = 'qtyAdd';
            } else if (e && e.key === 'ArrowDown') {
                e.preventDefault();
                name = 'qtySub';
            }
            let qtyCount = parseFloat(legInfo[index]?.count);
            if (isNaN(qtyCount)) return;
            if (name === "qtySub") {
                if (qtyCount - 1 !== 0) {
                    qtyCount -= 1;
                }
            } else if (name === "qtyAdd") {
                qtyCount += 1;
            }
            setLegInfo(prev => {
                let temp = [...prev];
                temp[index].count = qtyCount;
                return temp;
            });
        } else if (name.startsWith("price")) {
            let price = parseFloat(legInfo[index]?.legPrice);
            if (e && e.key === 'ArrowUp') {
                e.preventDefault();
                name = 'priceAdd';
            } else if (e && e.key === 'ArrowDown') {
                e.preventDefault();
                name = 'priceSub';
            }
            if (name === 'priceSub') {
                if (price - legInfo[index].priceTick !== 0) {
                    price -= legInfo[index].priceTick;
                }
            } else if (name === "priceAdd") {
                price += legInfo[index].priceTick;
            }
            if (isNaN(price)) return;
            price = price.toFixed(legInfo[0]?.extraInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]); //{/* Parshva S: BT: 107070 : 2/3/24 */ }
            setLegInfo(prev => {
                let temp = [...prev];
                temp[index].legPrice = price;
                return temp;
            });
        }
        handleBlink(name + index);

    }, [legInfo, setLegInfo]);

    const onHandledelete = useCallback((i) => {
        let temp = [...legInfo];
        temp.splice(i, 1);
        // Only updates redux which will trigger an update to state variable when user deletes any leg from order entry window
        dispatch(getMultiLegData(temp));
        if (isShowMarketDepth && i === isShowMarketDepth) {
            setIsShowMarketDepth(null);
        }
    }, [isShowMarketDepth, legInfo, dispatch]);
    // Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - Start
    const getValidateLTPPriceBand = useCallback(() => {
        let nTriggerPrice = parseFloat(orderInputs?.intradayTrigger);
        const legsThatHaveLtpPriceValidationError = [];
        if (selectOrderOption?.orderType?.includes(ORDER_ENTRY_TYPES.SL) && !isNaN(parseFloat(orderInputs?.slTrigger)) && parseFloat(orderInputs?.slTrigger) > 0) {
            nTriggerPrice = parseFloat(orderInputs?.slTrigger);
        } else {
            nTriggerPrice = parseFloat(orderInputs?.intradayTrigger);
        }
        // Loop over all legs in multileg order entry
        legInfo?.forEach((eachLeg) => {
            const objLtpValid = validateLTPPriceBand(scripInfo, scripInfo?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE], eachLeg.activeButtonToggleIndex, parseFloat(eachLeg?.legPrice), selectOrderOption?.orderType, ltpPriceBandMaster, nTriggerPrice);
            // if ltp price band validation happens
            if (!objLtpValid?.valid) {
                if (objLtpValid?.isRestrictive) {
                    // push to array with error message and mode of isRestrictive
                    legsThatHaveLtpPriceValidationError.push({ ...eachLeg, errorMsgToShow: objLtpValid.errorMsg, isRestrictive: true });
                } else {
                    // push to array with error message and mode of isInformative
                    legsThatHaveLtpPriceValidationError.push({ ...eachLeg, errorMsgToShow: objLtpValid.errorMsg, isInformative: true });
                }
            }
        });
        // If there was any price validation error in any leg then modal opens and below condition executes
        if (legsThatHaveLtpPriceValidationError.length) {
            dispatch(updateMultiLegOrderConfirmed(false));
            setLegsThatFailLtpPriceValidation(legsThatHaveLtpPriceValidationError);
            dispatch(handleModal([{ "LTP_PRICE_BAND_VALIDATION_ERROR_MODAL": true }]));
            return false;
        }
        // else order confirms
        else {
            dispatch(updateMultiLegOrderConfirmed(true));
            return true;
        }
    }, [dispatch, legInfo, ltpPriceBandMaster, orderInputs, scripInfo, selectOrderOption]);
    const survelienceConfirmationHandler = useCallback((nUserResp, scripInfo) => {
        dispatch(setCautionaryMessageFromPopup(nUserResp, scripInfo[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION], scripInfo[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripInfo[WATCHLIST_GRID_INDEX.TOKEN]));
        dispatch(toastConfig({ show: false }));
        if (nUserResp === 1) {
            return getValidateLTPPriceBand();
        } else {
            dispatch(toastConfig({ show: false }));
            return true;
        }
    }, [dispatch, getValidateLTPPriceBand]);
    const handlePlaceOrderButton = useCallback((e) => {
        e?.preventDefault();
        // Show Survilience alert and adds condition to check '0' as converting spread -> mulitleg array is filled with "0"
        if (scripInfo && scripInfo?.[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION] !== 0 && scripInfo?.[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION] !== "0" && !!scripInfo?.[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION]) { //Parshva S : 5/4/24 : BT 102679 Mltileg Order
            let strMsg = getGSMGradeDescriptionFromScrip(scripInfo);
            if (strMsg) {
                dispatch(toastConfig({ show: true, message: strMsg, button: [{ btnName: "Yes", className: "btn btn-solid ms-3", onClickHandler: () => survelienceConfirmationHandler(SURV_MEASURE_POPUP_ACTION.YES, scripInfo) }, { btnName: "No", className: "btn btn-outline-active ms-3", onClickHandler: () => survelienceConfirmationHandler(SURV_MEASURE_POPUP_ACTION.NO, scripInfo) }] }));
                return false;
            } else { }
        }
        else {
            // Ajitesh 02-07-2024 Validation for price tick in multileg
            let customScripPriceValidationFail = false;
            if (legInfo.length) {
                for (let i = 0; i < legInfo.length; i++) {
                    if (legInfo[i].orderType === ORDER_ENTRY_TYPES.RL) {
                        // Price tick
                        const scripTickValue = legInfo[i]?.priceTick * legInfo[i]?.decLoc;
                        // Decimal locator
                        const DecimalLocator = legInfo[i]?.decLoc;
                        const PriceinPaise = parseInt(Math.round(parseFloat((legInfo[i].legPrice * DecimalLocator))));
                        if (PriceinPaise % parseInt(scripTickValue) !== 0) {
                            const PriceTickInRs = (parseFloat(scripTickValue / DecimalLocator).toFixed(legInfo[i]?.decimalLocatorLength)); // use new decimal locator length field of specific leg
                            dispatch(toastConfig({ autoDismiss: true, timer: 5000, show: true, message: MSG_MASTER.NNSL62 + PriceTickInRs }));
                            customScripPriceValidationFail = true;
                            break;
                        }
                        // Check if user enters price as 0 which is not allowed
                        if (isNaN(parseFloat(legInfo[i].legPrice)) || parseFloat(legInfo[i].legPrice) === 0) {
                            dispatch(toastConfig({ autoDismiss: true, timer: 5000, show: true, message: MSG_MASTER.NNSL86 }));
                            customScripPriceValidationFail = true;
                            break;
                        }
                    }
                }
            }

            // Ajitesh 02-07-2024 If price tick is proper only then validate ltp
            if (customScripPriceValidationFail === false) {
                return getValidateLTPPriceBand();
            }
            else { }
        }
    }, [dispatch, getValidateLTPPriceBand, scripInfo, survelienceConfirmationHandler, legInfo]);
    useImperativeHandle(ref, () => ({
        handlePlaceOrderButton,
    }));

    const handleConfirmModal = useCallback(() => {
        dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': true }]));
        dispatch(handleModalData({
            data: {
                scripOrderInfo: scripInfo,
                arrInfo: legInfo,
                layoutType,
                orderEntryTab: ORDER_TYPES.MULTI_SCRIP,
                activeTabKey: ORDER_TYPES.MULTI_LEG,
            }
        }));
        dispatch(updateMultiLegOrderConfirmed(false));
    }, [dispatch, layoutType, legInfo, scripInfo]);
    // Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - End


    // Ajitesh adds source argument to find out if Add Leg or Search icon was clicked
    const handleOpenAddleg = (source) => {
        // Ajitesh 02-07-2024 Validation for price tick in multileg on Add leg button click
        let customScripPriceValidationFail = false;
        // Ajitesh adds condition to check if user clicked ADD LEG btn so validations can be checked
        if (multiLegData.length && source === MULTI_LEG.ADD_NEW_LEG) {
            for (let i = 0; i < multiLegData.length; i++) {
                if (multiLegData[i].orderType === "RL") {
                    // Price tick
                    const scripTickValue = multiLegData[i]?.priceTick * multiLegData[i]?.decLoc;
                    // Decimal locator
                    const DecimalLocator = multiLegData[i]?.decLoc;
                    const PriceinPaise = parseInt(Math.round(parseFloat((multiLegData[i].legPrice * DecimalLocator))));
                    if (PriceinPaise % parseInt(scripTickValue) !== 0) {
                        const PriceTickInRs = (parseFloat(scripTickValue) / DecimalLocator).toFixed(multiLegData[i]?.decimalLocatorLength);
                        dispatch(toastConfig({ autoDismiss: true, timer: 5000, show: true, message: MSG_MASTER.NNSL62 + PriceTickInRs }));
                        customScripPriceValidationFail = true;
                        break;
                    }
                    // Check if user enters price as 0 which is not allowed
                    if (isNaN(parseFloat(multiLegData[i].legPrice)) || parseFloat(multiLegData[i].legPrice) === 0) {
                        dispatch(toastConfig({ autoDismiss: true, timer: 5000, show: true, message: MSG_MASTER.NNSL86 }));
                        customScripPriceValidationFail = true;
                        break;
                    }
                }
            }
            // Ajitesh 02-07-2024 If price tick and price is proper only then allow to add new leg
            if (customScripPriceValidationFail === false) {
                dispatch(handleModal([{ "ADD_LEG_MODAL": true }]));
            }
        }
        else {
            // Ajitesh directly open add leg modal as user is trying to replace an existing leg
            dispatch(handleModal([{ "ADD_LEG_MODAL": true }]));
        }

    };

    // Function called when user clicks on Add Leg btn to add an extra third leg
    const handleAddExtraLeg = useCallback(async (data, isOptionChain = false) => {
        let exchangeId, token;
        // Ajitesh 24-06-2024 Adds extra condition to be called when user adds option contract as 3rd leg start
        if (isOptionChain && data.source === "legAdd") {
            // Ajitesh 16-07-2024 to get expory list when user adds 3rd leg from option chain dialog
            let info = dispatch(getWfhTouchlineLastTick());
            const allLegsData = data.data.map(leg => {
                return getLegObject({
                    ...leg,
                    info: leg?.extraInfo,
                    changeInLtp: leg?.changeInLtp,
                    ltpPercent: info[`${leg?.extraInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${leg?.extraInfo?.[WATCHLIST_GRID_INDEX.TOKEN]}`]?.[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
                    legPrice: info[`${leg?.extraInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${leg?.extraInfo?.[WATCHLIST_GRID_INDEX.TOKEN]}`]?.[TL_INDEX.LAST_TRADE_PRICE],
                    ltp: info[`${leg?.extraInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${leg?.extraInfo?.[WATCHLIST_GRID_INDEX.TOKEN]}`]?.[TL_INDEX.LAST_TRADE_PRICE],
                    symbol: leg?.symbol,
                    activeButtonToggleIndex: leg?.activeButtonToggleIndex,
                    instrument: leg?.instrument,
                    priceTick: leg?.priceTick,
                    expiryList: [...expiryListFromApi],
                    selectedExpiry: expiryListFromApi.find(el => el.nExpiryDate1 === scripInfo?.[WATCHLIST_GRID_INDEX.EXPIRYDATE]),
                    decLoc: scripInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR], // Ajitesh 29-07-2024 Adds correct decimal locator of base scrip as base scrip same as 3rd leg in case of current option chain implementation
                    decimalLocatorLength: leg?.extraInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] // Ajitesh 16-07-2024 Adds decimal locator length field for uniformity in JSX
                }, TL_INDEX, leg?.legNumber);
            });
            setLegInfo(() => allLegsData);
            setLegDataForChildComps(() => allLegsData);
        }
        // Ajitesh 24-06-2024 Condition to be called when user adds data from Futures tab as 3rd leg
        else if (isOptionChain === false && data?.source === 'legAdd') {
            let info = dispatch(getWfhTouchlineLastTick());
            // Only updates redux which will trigger an update to state variable when user adds a leg from Futures Screen
            dispatch(getMultiLegData([...multiLegData, getLegObject({
                ...data,
                info: data?.tlData,
                //info: convertTouclineIndexToWatchlistGridIndex(info[`${data?.segmentId}_${data?.token}`], scripInfo),
                changeInLtp: data?.changeInLtp,
                ltpPercent: info[`${data?.extraInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${data?.extraInfo?.[WATCHLIST_GRID_INDEX.TOKEN]}`]?.[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
                legPrice: data?.ltp,
                ltp: data?.ltp,
                symbol: multiLegData[0]?.symbol,
                activeButtonToggleIndex: data?.type,
                instrument: SCRIP_INSTRUMENTS.FUTSTK, // Ajitesh 29-07-2024 Adds FUTSTK when user clicks on B/S btns from Futures screen to show correct data in option chain screen in toast
                priceTick: multiLegData[0]?.priceTick,
                expiryList: multiLegData[0]?.expiryList,
                selectedExpiry: multiLegData[0]?.expiryList.find(el => el.nExpiryDate1 === data.expiryDate),
                decLoc: multiLegData[0]?.extraInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
                decimalLocatorLength: multiLegData[0]?.extraInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH], // Ajitesh 16-07-2024 Adds decimal locator length field as extraInfo arr of 116 scripinfo fields not received frmo futures tab
                exchange: multiLegData[0]?.exchange
            }, TL_INDEX, multiLegData?.length + 1)]));
            sendTouchlineRequest([{ exchangeId, token }]);
        } else if (isOptionChain === false && data?.source === 'legSearchAdd') {
            // Ajitesh 25-07-2024 Adds touchline and timeout only for NSECURR/BSECURR as data recvd does not have LTP and other data and so we take it from touchline
            sendTouchlineRequest([{ exchangeId: data?.[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: data?.[WATCHLIST_GRID_INDEX.TOKEN] }]);
            setTimeout(() => {
                let info = dispatch(getWfhTouchlineLastTick());
                // Checks condition to not add more than 3 legs if user keeps clicking on search result options and updates only redux which will update legInfo state for component
                if (multiLegData.length < MULTI_LEG.ORDER_MAX_LEGS) {
                    dispatch(getMultiLegData([...multiLegData, getLegObject({
                        ...data,
                        info: Object.values(data),
                        //info: convertTouclineIndexToWatchlistGridIndex(info[`${data?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${data?.[WATCHLIST_GRID_INDEX.TOKEN]}`] ?? Object.values(data), scripInfo),
                        expiryList: [...expiryListFromApi],
                        selectedExpiry: expiryListFromApi.find(el => el.nExpiryDate1 === data?.[WATCHLIST_GRID_INDEX.EXPIRYDATE]),
                        decLoc: data?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
                        decimalLocatorLength: data?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH],
                        // Ajitesh 12-09-2024 Adds conditions to below 4 properties to take data from touchline or show 0s with proper digits after decimal
                        changeInLtp: info[`${data?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${data?.[WATCHLIST_GRID_INDEX.TOKEN]}`] ? info[`${data?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${data?.[WATCHLIST_GRID_INDEX.TOKEN]}`]?.[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] : parseFloat("0").toFixed(data[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]),
                        legPrice: info[`${data?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${data?.[WATCHLIST_GRID_INDEX.TOKEN]}`] ? info[`${data?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${data?.[WATCHLIST_GRID_INDEX.TOKEN]}`]?.[TL_INDEX.LAST_TRADE_PRICE] : parseFloat("0").toFixed(data[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]),
                        ltp: info[`${data?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${data?.[WATCHLIST_GRID_INDEX.TOKEN]}`] ? info[`${data?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${data?.[WATCHLIST_GRID_INDEX.TOKEN]}`]?.[TL_INDEX.LAST_TRADE_PRICE] : parseFloat("0").toFixed(data[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]),
                        ltpPercent: info[`${data?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${data?.[WATCHLIST_GRID_INDEX.TOKEN]}`] ? info[`${data?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]}_${data?.[WATCHLIST_GRID_INDEX.TOKEN]}`]?.[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE] : parseFloat("0").toFixed(2),
                        symbol: data?.[WATCHLIST_GRID_INDEX.SYMBOL],
                        activeButtonToggleIndex: 0,
                        instrument: data?.[WATCHLIST_GRID_INDEX.INSTRUMENT],
                        priceTick: data?.[WATCHLIST_GRID_INDEX.PRICE_TICK],
                        ask_qty: data?.[WATCHLIST_GRID_INDEX.REGULAR_LOT], // Ajitesh 25-09-2024 adds property to show proper lot size when new currency or commodity leg is added
                        expiryDate: moment(data?.[WATCHLIST_GRID_INDEX.EXPIRYDATE]).format('YYYY-MM-DD'),
                        exchange: data?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT],
                    }, WATCHLIST_GRID_INDEX, multiLegData.length + 1)]));
                }
                else {
                    return;
                }
            }, 300);
        }
        dispatch(handleModal([{ "ADD_LEG_MODAL": false }]));
    }, [dispatch, multiLegData, expiryListFromApi, scripInfo]);

    // Ajitesh 08-10-2024 Modify function to set proper scrip for which we can get initial two legs for multileg order in sidetray
    const handleSelectScripFromGlobalSearch = useCallback((selectedScrip) => {
        if (layoutType === LAYOUT_TYPE.VERTICAL) {
            /**
             * When user clicks back from confirm screen and sidetray re-renders check if first leg token is same as scrip selected in WL token and if yes no need to do anything
             * If user deletes the first leg then on clicking back all added legs will be removed and data will be reset as token validation fails
             * when user converts spread -> multileg comparing ISIN_CODE to check if leg data received from api has same ISIN_CODE as underlying spread scrip in WL
             * eg tcsmayjune25 bse scrip in WL has isin code as 613 and isin code received from api for both legs is 613
             */
            if (multiLegData.filter(leg => leg.extraInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === selectedScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]).length > 0) { }
            // when user changes selection in WL; resets everything as sidetray is rendered
            else {
                dispatch(getMultiScriptSecongLegSuccess({}));
                setScripInfo(selectedScrip);
                dispatch(getMultiLegData([])); // Ajitesh 09-10-2024 Empties multileg data to get new multileg data when new scrip is selected in watchlist
                setRunOnce(false);
                setShowSearchBar(false);
                dispatch(getScripOrderInfo({ isBuySell: activeButtonToggleIndex, activeExchangeId: selectedScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: selectedScrip }));
            }
        }
        // horizontal view to trigger reset and flow of getting second leg data
        else {
            dispatch(getMultiScriptSecongLegSuccess({}));
            setScripInfo(selectedScrip);
        }
    }, [dispatch, activeButtonToggleIndex, layoutType, multiLegData]);

    const handleMultiScripTouchline = useCallback((touchline) => {
        setLegInfo(prev => {
            let temp = [...prev];
            let nIndex = temp.findIndex(item => item.extraInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === touchline[TL_INDEX.SEGMENT_ID] + "_" + touchline[TL_INDEX.TOKEN]);
            if (nIndex > -1) {
                temp[nIndex] = {
                    ...temp[nIndex],
                    changeInLtp: parseFloat(touchline[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]).toFixed(legInfo[0]?.extraInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]),
                    ltpPercent: touchline[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
                    ltp: touchline[TL_INDEX.LAST_TRADE_PRICE],
                };
            }
            return temp;
        });
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [legDataForChildComps]);
    useWFHMessages('touchline', (e) => {
        multiLegData?.forEach((eachScrip) => {
            let segMentIdandToke = eachScrip.extraInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN];
            if (segMentIdandToke === e.detail[TL_INDEX.SEGMENT_ID] + '_' + e.detail[TL_INDEX?.TOKEN]) {
                handleMultiScripTouchline(e.detail);
            }
        });
        /* legInfo.forEach((el, i) => {
            if (el.token === e.detail?.[TL_INDEX.TOKEN]) {
                setLegInfo(prev => {
                    let temp = [...prev];
                    temp[i] = {
                        ...temp[i],
                        changeInLtp: parseFloat(e.detail?.[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]).toFixed(legInfo[0]?.extraInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]),
                        ltpPercent: e.detail?.[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
                        ltp: e.detail?.[TL_INDEX.LAST_TRADE_PRICE],
                    };
                    return temp;
                });
            }
        }); */

    });
    //Vaibhav Singh: 24-11-23:BT-106776: BrokerageModal for Spread and Multileg Implemented : Start
    useEffect(() => {
        const objBrokerageData = getAppInfoData(APP_INFO_PARAMS.APP_BROKERAGE_MODE, appInfo);
        setShowBrokerage(objBrokerageData);
    }, [appInfo]);
    //Vaibhav Singh: 24-11-23:BT-106776: BrokerageModal for Spread and Multileg Implemented : End

    // Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - Start
    useEffect(() => {
        if (isOrderConfirmed && layoutType === LAYOUT_TYPE.HORIZONTAL) {
            handleConfirmModal();
        } else { }
    }, [handleConfirmModal, isOrderConfirmed, layoutType]);
    // Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - End
    useEffect(() => {
        // For normal derivative scrips in watchlist and for EQ scrips that show option chain option in overview we need to allow multileg
        if (scripInfo && (scripInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE] === DISPLAY_EXCHANGE_NAME.NCDEX_EXCHANGE_TEXT || scripInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES)) {
            setMultiLegAllowed(false);
        } else if ((scripInfo && scripInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] !== SCRIP_INSTRUMENTS.EQUITIES) || multiLegData?.length) {
            setMultiLegAllowed(true);
        }
        // For normal EQ scrips where option chain is not shown in overview and user tries to do multileg order from order entry; we restrict it and show apt msg
        else {
            setMultiLegAllowed(false);
        }
    }, [scripInfo, multiLegData]);

    useEffect(() => {
        if (scripInfo?.length && scripInfo?.length !== 0 && legInfo?.length >= 2 && (legInfo[0]?.ltp === '0.00' && legInfo[1]?.ltp === '0.00')) {
            let info = dispatch(getWfhTouchlineLastTick());
            legInfo.forEach((el, i) => {
                let tempInfo = info[`${scripInfo?.[0]}_${el?.token}`];
                if (el.token === tempInfo?.[TL_INDEX.TOKEN]) {
                    setLegInfo(prev => {
                        let temp = [...prev];
                        temp[i] = {
                            ...temp[i],
                            changeInLtp: parseFloat(tempInfo?.[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]).toFixed(legInfo[0]?.extraInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]),
                            ltpPercent: tempInfo?.[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
                            ltp: tempInfo?.[TL_INDEX.LAST_TRADE_PRICE],
                        };
                        return temp;
                    });
                }
            });
        }
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [dispatch, scripInfo]);

    // Ajitesh This is a simplified version of above useEffect that passes new selected scrip from watchlist.
    useEffect(() => {
        if (scripInfo === null) {
            handleSelectScripFromGlobalSearch(orderInfo);
        }
        else {
            // Modifies the condition so that segment id and token combo is compared instead of just token to trigger code correctly when user switches from TCS NSE EQ to TCS FUT;
            if (orderInfo.length && scripInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] !== orderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {

                handleSelectScripFromGlobalSearch(orderInfo);
            }
        }
        //
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [orderInfo]);

    // const handleGetExpiryForScripFromApi = useCallback(async () => {
    //     const list = await _getExpiryForScrip(whatsHotData, {
    //         segment_id: orderInfo?.[WATCHLIST_GRID_INDEX?.SEGMENT_ID],
    //         symbol: orderInfo?.[WATCHLIST_GRID_INDEX.SYMBOL],
    //         instrument: orderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE]?.includes(DISPLAY_EXCHANGE_NAME.MCX_EXCHANGE_TEXT) || orderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSECOMM_DERIVATIVES ? SCRIP_INSTRUMENTS.FUTCOM
    //             : orderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSECOMM_DERIVATIVES ? SCRIP_INSTRUMENTS.FUTBLN : 'FUT' + orderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT]?.substr(3, 3)
    //     });
    //     Promise.resolve(list).then((data) => {
    //         if (multiLegData[0]?.expiryList?.length === 0) {
    //             multiLegData[0].expiryList = [...data];
    //             // dispatch(getMultiLegData([...multiLegData]));
    //         }
    //         setExpiryListFromApi([...data]);
    //     }, (error) => {
    //         console.error("Error in fetching data", error);
    //     });
    // }, [orderInfo, multiLegData, dispatch, whatsHotData]);

    // Ajitesh: Function to get expiry data for scrips in one place to avoid multiple api calls
    // useEffect(() => {
    //     if (orderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] !== SCRIP_INSTRUMENTS.EQUITIES) {
    //         handleGetExpiryForScripFromApi();
    //     }
    // }, [orderInfo, whatsHotData, handleGetExpiryForScripFromApi]);

    useEffect(() => {
        if (scripInfo?.length !== 0 && (scripInfo?.[WATCHLIST_GRID_INDEX.EXPIRYDATE] !== "" && scripInfo?.[WATCHLIST_GRID_INDEX.NSPREAD] === 0 && scripInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] !== SCRIP_INSTRUMENTS.EQUITIES)) {
            dispatch(getMultiScriptSecongLeg({
                expiryDate: FirstLegExpDate,
                instrument: scripInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT],
                mktSegid: scripInfo?.[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                optiontype: scripInfo?.[WATCHLIST_GRID_INDEX.OPTIONTYPE],
                // Ajitesh 03/06/2024 - Adds decimal locator to get correct strike price responsefrom API
                strikeprice: scripInfo?.[WATCHLIST_GRID_INDEX.STRIKEPRICE] === '' ? "" : parseFloat(scripInfo?.[WATCHLIST_GRID_INDEX.STRIKEPRICE]) * scripInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
                symbol: scripInfo?.[WATCHLIST_GRID_INDEX.SYMBOL]
            })
            );
            // sendTouchlineRequest([{ exchangeId: scripInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scripInfo?.[WATCHLIST_GRID_INDEX.TOKEN] }]);
        }
    }, [FirstLegExpDate, dispatch, scripInfo]);
    useEffect(() => {
        // Ajitesh - 30/05/2024 - Changes condition to show updated touchline data on all multileg screens
        if (scripInfo && scripInfo?.length !== 0 && !touchlineFlag && ((!!multiScriptSecondLeg && Object?.keys(multiScriptSecondLeg)?.length) || (!!multiLegData[1]))) {
            let tempToken = multiScriptSecondLeg?.nToken !== undefined ? multiScriptSecondLeg?.nToken : multiLegData[1].token;
            sendTouchlineRequest([{ exchangeId: scripInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scripInfo?.[WATCHLIST_GRID_INDEX.TOKEN] }]);
            sendTouchlineRequest([{ exchangeId: scripInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: tempToken }]);
            setTouchlineFlag(true);
            // Ajitesh 30-08-2024 If user comes to multi leg order entry from option chain after selecting 2-3 legs then this below condition will trigger and get data for Futures tab
            if (multiLegData.length && Object.keys(multiScriptSecondLeg).length === 0) {
                setLegDataForChildComps(multiLegData);
            }
        }
    }, [multiLegData, scripInfo, touchlineFlag, multiScriptSecondLeg]);
    useEffect(() => {
        if (scripInfo?.length !== 0 && scripInfo?.[WATCHLIST_GRID_INDEX.EXPIRYDATE] !== "" && scripInfo?.[WATCHLIST_GRID_INDEX.NSPREAD] === 0) {
            if (Object?.keys(multiScriptSecondLeg)?.length) {
                let temp = [];
                setTimeout(() => {
                    let info = dispatch(getWfhTouchlineLastTick());
                    let secondLegExpiryDate = new Date('01/01/1980');
                    secondLegExpiryDate = secondLegExpiryDate.setSeconds(multiScriptSecondLeg?.nExpiryDate);
                    // First leg info
                    let firstinfo = info[`${scripInfo?.[0]}_${scripInfo?.[1]}`];
                    // If first leg info is not found in touchline create and fill arrays with 0s
                    if (firstinfo === undefined) {
                        firstinfo = new Array(Object.keys(TL_INDEX).length).fill('0.00');
                        firstinfo[TL_INDEX.SEGMENT_ID] = scripInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID];
                        firstinfo[TL_INDEX.TOKEN] = scripInfo[WATCHLIST_GRID_INDEX.TOKEN];
                    }
                    // second leg info
                    info = info[`${scripInfo?.[0]}_${multiScriptSecondLeg?.nToken}`];
                    // If second leg info is not found in touchline create and fill arrays with 0s
                    if (info === undefined) {
                        info = new Array(Object.keys(TL_INDEX).length).fill('0.00');
                        info[TL_INDEX.SEGMENT_ID] = scripInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID];
                        info[TL_INDEX.TOKEN] = multiScriptSecondLeg.nToken;
                    }
                    // Ajitesh - 30/05/2024 - Adds data to show updated touchline data on all multileg screens
                    temp[0] = getLegObject({
                        info: convertTouclineIndexToWatchlistGridIndex(firstinfo, scripInfo), changeInLtp: firstinfo?.[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE],
                        ltpPercent: firstinfo?.[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
                        // Ajitesh 12-09-2024 Adds conditions to below property to take data from touchline or show 0s with proper digits after decimal
                        ltp: parseFloat(firstinfo?.[TL_INDEX.LAST_TRADE_PRICE]).toFixed(scripInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]), expiryDate: FirstLegExpDate, activeButtonToggleIndex, exchange: scripInfo?.[WATCHLIST_GRID_INDEX?.EXCHANGE_SEGMENT], decLoc: scripInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR], decimalLocatorLength: scripInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]
                    }, WATCHLIST_GRID_INDEX, 1);
                    temp[1] = getLegObject({
                        info: convertTouclineIndexToWatchlistGridIndex(info, scripInfo),
                        token: multiScriptSecondLeg?.nToken,
                        expiryDate: moment(secondLegExpiryDate).format('YYYY-MM-DD'),
                        symbol: multiScriptSecondLeg?.sSymbol,
                        ask_qty: multiScriptSecondLeg?.nRegularLot,
                        // Ajitesh 12-09-2024 Adds conditions to below 4 properties to take data from touchline or show 0s with proper digits after decimal
                        changeInLtp: info?.[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE], ltpPercent: info?.[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
                        legPrice: parseFloat(info?.[TL_INDEX.LAST_TRADE_PRICE]).toFixed(scripInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]),
                        ltp: parseFloat(info?.[TL_INDEX.LAST_TRADE_PRICE]).toFixed(scripInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]),
                        activeButtonToggleIndex: getActiveButtonToggleIndex(activeButtonToggleIndex),
                        priceTick: temp[0]?.priceTick,
                        strikeprice: (parseInt(multiScriptSecondLeg?.nStrikePrice) / scripInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]).toFixed(scripInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]),
                        optiontype: multiScriptSecondLeg?.sOptionType,
                        instrument: multiScriptSecondLeg?.sInstrumentName,
                        exchange: scripInfo?.[WATCHLIST_GRID_INDEX?.EXCHANGE_SEGMENT],
                        decLoc: scripInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
                        decimalLocatorLength: scripInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]
                    }, WATCHLIST_GRID_INDEX, 2);
                    temp[1]["extraInfo"] = temp[1]?.extraInfo?.length > 0 ? convertTouclineIndexToWatchlistGridIndex(temp[1]?.extraInfo, scripInfo) : [];
                    temp[1]["extraInfo"][WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR_LENGTH] = temp[0]?.extraInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH];
                    temp[0].expiryList = temp[1].expiryList = [...expiryListFromApi];
                    temp[0]["selectedExpiry"] = expiryListFromApi.find(el => el.nExpiryDate1 === scripInfo?.[WATCHLIST_GRID_INDEX.EXPIRYDATE]);
                    temp[1]["selectedExpiry"] = expiryListFromApi.find(el => el.nExpiryDate1 === (moment(secondLegExpiryDate).format('DDMMMYYYY')).toUpperCase());
                }, 300);
                setTimeout(() => {
                    setLegInfo(temp);
                    dispatch(getMultiLegData([...temp]));
                    setLegDataForChildComps(temp);
                    setRunOnce(true);
                }, 800);
            }
            // Ajitesh - 05/06/2025 - Adds else part to get futures data or strike price data for next futures/options contract from api
            else if (multiLegData?.length < 2) {
                let temp = [];
                setTimeout(() => {
                    let info = dispatch(getWfhTouchlineLastTick());
                    let firstinfo = info[`${scripInfo?.[0]}_${scripInfo?.[1]}`];
                    //info = info[`${scripInfo?.[0]}_${multiScriptSecondLeg?.nToken}`];
                    temp[0] = getLegObject({
                        info: scripInfo,
                        changeInLtp: firstinfo?.[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE],
                        ltpPercent: firstinfo?.[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
                        ltp: firstinfo?.[TL_INDEX.LAST_TRADE_PRICE],
                        expiryDate: FirstLegExpDate,
                        activeButtonToggleIndex,
                        exchange: scripInfo?.[WATCHLIST_GRID_INDEX?.EXCHANGE_SEGMENT],
                        decLoc: scripInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
                        decimalLocatorLength: scripInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]
                    }, WATCHLIST_GRID_INDEX, 1);

                    temp[0].expiryList = [...expiryListFromApi];
                    temp[0]["selectedExpiry"] = expiryListFromApi.find(el => el.nExpiryDate1 === scripInfo?.[WATCHLIST_GRID_INDEX.EXPIRYDATE]);
                }, 300);
                setTimeout(() => {
                    setLegInfo(temp);
                    setLegDataForChildComps(temp);
                    setRunOnce(true);
                }, 800);
            }
            else { }
        }
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [FirstLegExpDate, activeButtonToggleIndex, dispatch, multiScriptSecondLeg, scripInfo, whatsHotData]);

    // Ajitesh 19-07 This effect maintains copy of legInfo as it is not constantly re rendered
    /* useEffect(() => {
        if(legDataForChildComps.length) {
            setArrRowSelection(legDataForChildComps); // arrRowSelection is passed down to lower level then diff copy is maintained to save state between futures and options tabs until user clicks Add Leg button or B/S btn
        }
    }, [legDataForChildComps]); */
    // useEffect(() => {
    //     if (!Array.isArray(objMultiLeg) && Object.keys(objMultiLeg).length > 0) {
    //         setLegInfo(prev => {
    //             return [...prev, getLegObject(objMultiLeg)]
    //         })
    //     }
    // }, [objMultiLeg])

    //Ameersha N :BREEZE -- 19-01-2023 -start
    const handleLegPricekeyDown = useCallback((event, type, i) => {
        if (event?.key === '-') {
            event.preventDefault();
        }
        if (event?.key === 'ArrowUp' || event?.key === 'ArrowDown') {
            onHandleClick(type, i, event);
        } else {

        }

    }, [onHandleClick]);
    //Ameersha N :BREEZE -- 19-01-2023 -End

    useEffect(() => {
        setIsLoader(true);
        setTimeout(() => {
            setIsLoader(false);
        }, 800);
    }, []);

    //Ameersha N :BREEZE -- 19-01-2023 -start
    const comvertExpiryDate = useCallback((expiryDate) => {
        return moment(expiryDate).format('DDMMMYYYY')?.toString();
    }, []);
    //Ameersha N :BREEZE -- 19-01-2023-End

    // Fn to open overview modal on click of eye icon from multileg sidetray
    const handleScripOverview = (orderInfo) => {
        dispatch(setScripOverviewData(orderInfo));
        dispatch(updateScripAndOptionData({ instrumentName: orderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT], symbol: orderInfo?.[WATCHLIST_GRID_INDEX.SYMBOL], instrument: orderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT], id: orderInfo?.[WATCHLIST_GRID_INDEX?.SEGMENT_ID], token: orderInfo?.[WATCHLIST_GRID_INDEX.ASSET_TOKEN] === 0 ? orderInfo?.[WATCHLIST_GRID_INDEX.TOKEN] : orderInfo?.[WATCHLIST_GRID_INDEX.ASSET_TOKEN], bestFive: true, location: OPTION_CHAIN.OVERVIEW }));
        dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }], true));
        dispatch(handleModalData({ tab: 'overview' }));
        if (layoutType === LAYOUT_TYPE.VERTICAL) {
            setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; }); //Azeem K :25-11-2024 :cloe side tray on click of overview
        }
    };

    // Fn to handle price to be shown in price input box when user clicks bid/ask in market depth
    const handlePriceOnMktDepthClick = (e) => {
        if (legInfo[isShowMarketDepth].orderType === ORDER_ENTRY_TYPES.RL) {
            let newObj = deepClone(legInfo);
            newObj[isShowMarketDepth].legPrice = e.toFixed(scripInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
            setLegInfo(newObj);
            // Adding below line to update redux to have updated prices if changes made from bid/ask mkt depth chart to shown on confirmation screen
            dispatch(getMultiLegData(newObj));
        }
    };
    return (
        layoutType === LAYOUT_TYPE.HORIZONTAL ?
            <>
                {/* Vaibhav Singh : BT-106776 - 08-11-2023-  Added Modal - Start */}
                {/* <BrokerageCharges brokerageParams={brokerageParams} /> */}
                <BrokerageModalMultiLeg sentFrom={'multileg'} />
                <LoginLoader spinner={isLoader} spinnerContent={"Loading"} />
                {/* Vaibhav Singh : BT-106776 - 08-11-2023-  Added Modal - End */}
                <Container fluid className='p-0'>
                    <form onSubmit={handlePlaceOrderButton}>
                        {multiLegAllowed ?
                            <div>
                                <Row className='g-0'>
                                    <Col>
                                        <div className='table-responsive my-3'>
                                            <table className='table table-sm table-hover table-striped table-bordered oe-table'>
                                                <thead>
                                                    <tr>
                                                        {objDropdownOptions?.heading?.map((element, i) =>
                                                            <th key={i} className='align-middle text-center text-nowrap'>
                                                                <div className='font-size1 color-subtext'>{element}</div>
                                                            </th>
                                                        )}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {legInfo?.length > 0 && legInfo?.map((element, i) => {
                                                        return <tr key={i} className={`${isShowMarketDepth === i ? 'oe-multileg-table-active-background' : ''} h_60`}>
                                                            <td className={`align-start text-nowrap pt-2 ${isShowMarketDepth === i ? 'oe-multileg-table-active-background' : ''}`}>
                                                                <div className='Bzmodalselect-dropdown'>
                                                                    <BzDropdown value={element?.activeButtonToggleIndex === 0 ? "BUY" : "SELL"} onChange={(e) => handleDropdownChange(e, i)} name="activeButtonToggleIndex">
                                                                        <Dropdown.Toggle className={`btn-default font-medium ${element?.activeButtonToggleIndex === 0 ? "color-positive" : "color-negative"}`}>{element?.activeButtonToggleIndex === 0 ? "BUY" : "SELL"}</Dropdown.Toggle>
                                                                        <Dropdown.Menu>
                                                                            <Dropdown.Item onClick={() => handleDropdownChange({ target: { value: "BUY", name: 'activeButtonToggleIndex' } }, i)}>BUY</Dropdown.Item>
                                                                            <Dropdown.Item onClick={() => handleDropdownChange({ target: { value: "SELL", name: 'activeButtonToggleIndex' } }, i)}>SELL</Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                    </BzDropdown>
                                                                </div>
                                                            </td>
                                                            <td className={`align-start text-nowrap pt-2 ${isShowMarketDepth === i ? 'oe-multileg-table-active-background' : ''}`}>
                                                                <div className='d-flex justify-content-between align-items-start'>
                                                                    <div className='d-flex flex-column justify-content-start align-items-start me-2'>
                                                                        <div className='font-medium font-size2 color-text text-uppercase'>{element?.symbol}</div>
                                                                        <div className='d-flex align-items-start'>
                                                                            <div className='font-medium font-size1 color-text'>{element?.ltp}</div>
                                                                            <div className={`font-regular font-size1 color-text ms-1 ${parseFloat(element?.ltpPercent) >= 0 ? 'color-positive' : 'color-negative'}`}> {parseFloat(element?.changeInLtp) > 0 ? '+' : ''}{parseFloat(element?.changeInLtp).toFixed(element?.decimalLocatorLength) || (0).toFixed(element?.decimalLocatorLength)} ({element?.ltpPercent}%)</div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='d-flex justify-content-end align-items-start'>
                                                                        <BzButton className='icon-btn p-0 px-1' type='button' onClick={() => { setSelectedLegToUpdate(i); handleOpenAddleg(MULTI_LEG.UPDATE_EXISTING_LEG); }}>
                                                                            <span className='icon-14 icon-search icon-dark'></span>
                                                                        </BzButton>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className='align-start text-nowrap pt-2'>
                                                                <div className='d-flex justify-content-center align-items-center'>
                                                                    <div className='font-regular font-size1 color-text text-uppercase'>{comvertExpiryDate(element?.expiryDate)?.toUpperCase()}</div>
                                                                </div>
                                                            </td>
                                                            <td className='align-start text-nowrap pt-2'>
                                                                <div className='d-flex justify-content-center align-items-center'>
                                                                    <div className='font-regular font-size1 color-text text-uppercase'>{element?.strikeprice}</div>
                                                                </div>
                                                            </td>
                                                            <td className='align-start text-nowrap pt-2'>
                                                                <div className='d-flex justify-content-center align-items-center'>
                                                                    <div className='font-regular font-size1 color-text text-uppercase'>{element?.optiontype}</div>
                                                                </div>
                                                            </td>
                                                            <td className='align-start text-nowrap pt-2'>
                                                                <div className='Bzmodalselect-dropdown'>
                                                                    <BzDropdown>
                                                                        <Dropdown.Toggle className='btn-default'>{element?.orderType}</Dropdown.Toggle>
                                                                        <Dropdown.Menu>
                                                                            <Dropdown.Item onClick={() => handleDropdownChange({ target: { value: "RL-MKT", name: 'orderType' } }, i)}>RL-MKT</Dropdown.Item>
                                                                            <Dropdown.Item onClick={() => handleDropdownChange({ target: { value: "RL", name: 'orderType' } }, i)}>RL</Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                    </BzDropdown>
                                                                </div>
                                                            </td>
                                                            <td className='align-start text-nowrap pt-2'>
                                                                <div className='input-group position-relative'>
                                                                    <div className='icon-12 icon-order-decrease input-number-left-wrap' id={'qtySub' + i} onClick={() => onHandleClick('qtySub', i)}></div>
                                                                    <BzInputText size='sm' maxLength={8} type='text' autoFocus={i === 0} placeholder="0" className='font-regular text-center w_100' name="count" onBlur={(e) => { handleBlur(e, 'count', i); }} onChange={(e) => handleChange(e, 'count', i)}
                                                                        value={element?.count} onKeyDown={(e) => { onHandleClick('qty', i, e); }} />
                                                                    <div className='icon-12 icon-order-increase input-number-right-wrap' id={'qtyAdd' + i} onClick={() => onHandleClick("qtyAdd", i)}></div>
                                                                </div>
                                                                <div className='font-regular font-size1 color-subtext text-center mt-1'>(1 Lot = {element?.ask_qty} Qty)</div>
                                                            </td>
                                                            <td className='align-start text-nowrap pt-2'>
                                                                <div className='d-flex align-items-center'>
                                                                    <div className='input-group position-relative'>
                                                                        <div className={`icon-12 icon-order-decrease input-number-left-wrap ${element?.orderType === 'RL-MKT' ? 'disabled' : ''}`} id={'priceSub' + i} onClick={() => {
                                                                            if (element?.orderType !== 'RL-MKT') {
                                                                                onHandleClick("priceSub", i);
                                                                            }
                                                                        }}>
                                                                        </div>
                                                                        <BzInputText size='sm' maxLength={10} type='text' placeholder="0.00" disabled={element?.orderType === 'RL-MKT'} className='font-regular text-center w_100' name="legPrice" onBlur={(e) => { handleBlur(e, 'legPrice', i); }} onChange={(e) => handleChange(e, 'legPrice', i)}
                                                                            value={element?.orderType == 'RL-MKT' ? element?.ltp : element?.legPrice} onKeyDown={(e) => { handleLegPricekeyDown(e, 'price', i, e.key); }} />
                                                                        <div className={`icon-12 icon-order-increase input-number-right-wrap ${element?.orderType === 'RL-MKT' ? 'disabled' : ''}`} id={'priceAdd' + i} onClick={() => {
                                                                            if (element?.orderType !== 'RL-MKT') {
                                                                                onHandleClick("priceAdd", i);
                                                                            }
                                                                        }}>
                                                                        </div>
                                                                    </div>
                                                                    <div className='icon-20 icon-marketdepth ms-2 me-1' onClick={() => onhandleMarketDepth(element?.extraInfo, i, element?.instrument)}></div>
                                                                </div>
                                                            </td>
                                                            <td className='align-start text-nowrap text-center pt-2'>
                                                                <div className='font-regular font-size1 color-subtext'>IOC</div>
                                                            </td>
                                                            <td className='align-start text-nowrap text-center pt-2'>
                                                                <BzButton type='button' className='icon-btn' disabled={legInfo?.length <= 2} onClick={() => {
                                                                    if (legInfo?.length > 2) {
                                                                        onHandledelete(i);
                                                                    }
                                                                }}> <span className={`icon-16 icon-close-fill ${legInfo?.length <= 2 ? "icon-disabled" : ""} icon-primary`}></span></BzButton>
                                                            </td>
                                                        </tr>;
                                                    }
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-4'>
                                    <Col>
                                        <BzButton type='button' className='btn btn-sm btn-primary d-flex align-items-center' onClick={() => { setSelectedLegToUpdate(null); handleOpenAddleg(MULTI_LEG.ADD_NEW_LEG); }} disabled={legInfo?.length === MULTI_LEG.ORDER_MAX_LEGS}>Add Leg
                                            <div className='icon-12 icon-add-circle-fill icon-light ms-2'></div>
                                        </BzButton>
                                    </Col>
                                </Row>
                            </div> :
                            <Row className='g-0 mt-3 mb-4'>
                                <Col md={8} className='m-auto oe-note-card'>
                                    <div className='d-flex align-items-center'>
                                        <div className='icon-16 icon-info icon-dark'></div>
                                        <div className='font-medium font-size3 color-text ms-2'>Please note</div>
                                    </div>

                                    <div className='font-regular font-size3 color-text py-2'>MultiLeg Orders can only be placed for <span className='font-medium'>Futures / Options / Commodity / Currency </span>segments (For non NCDEX segment). For Equity stocks please place a Single Scrip / Order Cart!</div>
                                </Col>
                            </Row>
                        }
                        <Row className='bdr-top py-2'>
                            <Col md={7} className='d-flex justify-content-start align-items-center'>
                                {/* <div className='font-medium font-size2 color-text'>Approx. Margin: &#8377;<span className='font-regular ms-1'>{arrMarginInfo?.data?.result?.ApproxMargin}</span> <span className='mx-1'>/</span> </div>
                            <div className='font-medium font-size2 color-text'>Available Margin: &#8377;<span className='font-regular ms-1'>{arrMarginInfo?.data?.result?.AvailableMargin}</span></div>
                            <div className='d-flex align-items-center ms-3'>
                                <div className='icon-16 icon-refresh  background-textual-link-withicon'></div>
                                <div className='font-medium font-size2 color-textual-link-withicon ms-2' onClick={marginInfoHandler}>Update</div>
                            </div> */}
                            </Col>
                            {/* Vaibhav Singh : BT-106776 - 08-11-2023-  Added Modal - Start */}
                            <Col md={5} className='d-flex justify-content-end align-items-center'>
                                <BzButton className={`btn btn-md ${activeButtonToggleIndex === 0 ? 'btn-positive' : 'btn-negative'} text-capitalize`} disabled={legInfo?.length < 2} type='submit' onClick={handlePlaceOrderButton}>Place Order</BzButton>
                            </Col>
                            {/* Vaibhav Singh : BT-106776 - 08-11-2023-  Added Modal - ENd */}
                        </Row>
                        {
                            isShowMarketDepth !== null &&
                            <Row className='g-0 bdr-top px-2 py-2'>
                                <Row className='g-0'>
                                    <Col md={12} className='d-flex justify-content-start align-items-center'>
                                        <Button className={marketDepthActiveTab === "MarketDepth" ? 'btn btn-sm btn-primary btn-rounded me-2' : 'btn btn-sm btn-default btn-rounded me-2'} onClick={() => setMarketDepthActiveTab('MarketDepth')}>Market Depth</Button>
                                        <Button className={marketDepthActiveTab === "supportResistance" ? 'btn btn-sm btn-primary btn-rounded' : 'btn btn-sm btn-default btn-rounded'} onClick={() => setMarketDepthActiveTab('supportResistance')}>Support/Resistance</Button>
                                    </Col>
                                </Row>
                                {marketDepthActiveTab === "MarketDepth" ? <AllExchangesMarketDepth onValueClick={(e) => handlePriceOnMktDepthClick(e)} heading={false} /> : marketDepthActiveTab === "supportResistance" ? <SupportResistance supportResistance={supportResistance} strViewFrom={SUPPORT_RESISTANCE_VIEW.ORDER_ENTRY} layoutType={layoutType} /> : null}
                            </Row>
                        }
                    </form>
                </Container>
                {/**Adding condition in legData prop as when 2nd scrip is not recvd from api of multileg then redux mulitleg remains blank which causes undefined error hence passing scripInfo */}
                {modals['ADD_LEG_MODAL'] && <AddLegMultiscriptModal legData={{ data: multiLegData.length ? multiLegData[0]?.extraInfo : scripInfo, legNumber: selectedLegToUpdate }} setThirdLegData={(data, isOptionChain) => { handleAddExtraLeg({ ...data }, isOptionChain); }} updateLegData={updateLegHandler} arrRowSelection={legDataForChildComps} />}
                {modals["LTP_PRICE_BAND_VALIDATION_ERROR_MODAL"] ? <LtpPriceBandValidationInfoModal legsThatFailLtpPriceValidation={legsThatFailLtpPriceValidation} /> : null}
            </>
            :
            (
                layoutType === LAYOUT_TYPE.VERTICAL ?
                    <div className='sticky-orderticket-multileg'>
                        <Container className='p-0 pb-3 px-3'>
                            {multiLegAllowed ?
                                <>

                                    <Row className='g-0 mb-2'>
                                        <Col md={8} className='text-start'>
                                            <div className='d-flex align-items-center'>
                                                <div className='font-medium font-size4 color-text text-uppercase me-2'>
                                                    {orderInfo?.[WATCHLIST_GRID_INDEX.SYMBOL]}
                                                </div>
                                                <div className='icon-16 icon-eye icon-dark me-2' onClick={() => handleScripOverview(orderInfo)}></div>
                                                <div className='icon-16 icon-search icon-dark' onClick={() => { setShowSearchBar(prev => !prev); }}></div>
                                            </div>
                                            <div className='font-regular font-size3 color-subtext'>{orderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT]}</div>
                                        </Col>
                                        <Col md={4} className='text-end'>
                                            <div className='font-medium font-size4 color-text'>{orderInfo?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]}</div>
                                            <div className={`font-regular font-size3 color-text ${Number(orderInfo?.[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]) > 0 ? 'color-positive' : Number(orderInfo?.[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]) < 0 ? 'color-negative' : ''}`}>
                                                {orderInfo?.[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]} ({orderInfo?.[WATCHLIST_GRID_INDEX.LTP_PERCENT]}%)
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 mb-2'>
                                        <Col md={12}>
                                            {
                                                showSearchBar ?
                                                    <InlineScripSeach ref={inlineSearchRef} handleSelectScripFromGlobalSearch={handleSelectScripFromGlobalSearch} />
                                                    :
                                                    null
                                            }
                                        </Col>
                                    </Row>
                                </> :

                                <Row className='g-0 oe-note-card mb-3'>
                                    <Col md={1} className='d-flex align-items-start'>
                                        <div className='icon-16 icon-info icon-dark'></div>
                                    </Col>
                                    <Col md={11}>
                                        <div className='font-regular font-size3 color-text'>
                                            Multi Leg Orders can only be placed for -
                                            <br />
                                            <span className='color-negative'>
                                                Futures / Options / Commodity / Currency segments (For non NCDEX segment).
                                            </span>
                                            &nbsp;Choose a non equity scrip from the search provided with the scrip name to proceed.
                                        </div>
                                    </Col>
                                </Row>

                            }
                            {/** Show leg info for all derivatives hence adding !== equities; if some special segment is not applicable can add this later here */}
                            {
                                multiLegAllowed ?
                                    <>
                                        {
                                            legInfo?.length > 0 && legInfo?.map((element, i) =>
                                                <div key={i} className='ordercart-card px-2 py-3 my-2'>
                                                    <Row className='g-0 mb-2'>
                                                        <Col>
                                                            <div className='d-flex gap-1 font-medium font-size3 color-text flex-wrap align-items-center'>
                                                                <div>{element?.symbol}</div>
                                                                {
                                                                    (element?.instrument === SCRIP_INSTRUMENTS.OPTFUT || element?.instrument === SCRIP_INSTRUMENTS.OPTIDX || element?.instrument === SCRIP_INSTRUMENTS.OPTSTK || element?.instrument === SCRIP_INSTRUMENTS.OPTCUR_TEXT || element?.instrument === SCRIP_INSTRUMENTS.OPTCOM_TEXT || element?.instrument === SCRIP_INSTRUMENTS.OPTIONS_TEXT) ?
                                                                        <>
                                                                            <div>{element?.optionType !== 'NA' ? element?.strikeprice : ''}</div>
                                                                            <div>{element?.optiontype}</div>
                                                                        </>
                                                                        :
                                                                        null
                                                                }
                                                                <div className='ms-1 icon-14 icon-search icon-dark' onClick={() => { setSelectedLegToUpdate(i); handleOpenAddleg(MULTI_LEG.UPDATE_EXISTING_LEG); }}></div>
                                                            </div>   {/* Bhagyashri P [14-12-2023] : class changes */}
                                                            <div className='d-flex align-items-center flex-wrap my-1'>
                                                                <div className='chips-wrap'>
                                                                    <div className='exchange-chip text-uppercase'>{EXCHANGE_NAME_LIVEPULSE?.[element?.exchange]}</div>
                                                                </div>
                                                                <div className='font-regular font-size1 color-subtext text-capitalize mx-2'>
                                                                    {moment(element?.expiryDate).format("DD MMM YYYY")}
                                                                </div>
                                                            </div>
                                                            <div className={`font-medium font-size3 ${element?.activeButtonToggleIndex === 0 ? "color-positive" : "color-negative"}`}>
                                                                {element?.activeButtonToggleIndex === 0 ? "Buy" : "Sell"}
                                                                <span className='font-regular color-text mx-1'>
                                                                    {element?.count} Lot ({element?.ask_qty}) @
                                                                </span>
                                                                <span className='font-regular color-text'>
                                                                    &#8377;{element?.legPrice}
                                                                </span>
                                                            </div>
                                                        </Col>
                                                        <Col md={3} className='d-flex justify-content-end'>
                                                            {
                                                                editKey !== i ?
                                                                    <>
                                                                        {
                                                                            legInfo.length > 2 ?
                                                                                <div className='icon-16 icon-delete icon-dark ms-3' onClick={() => { onHandledelete(i); }}></div>
                                                                                :
                                                                                null
                                                                        }
                                                                        <div className='icon-16 icon-edit icon-dark ms-3' onClick={() => { setEditKey(i); }}></div>
                                                                    </>
                                                                    :
                                                                    <div className='icon-16 icon-arrowup icon-dark ms-3' onClick={() => { setEditKey(-1); }}></div>
                                                            }
                                                        </Col>
                                                    </Row>
                                                    {
                                                        editKey === i ?
                                                            <>
                                                                <Row className='g-0 mb-2 align-items-center'>
                                                                    <Col className='d-flex justify-content-start'>
                                                                        <div className='pt-2'>
                                                                            <div className='font-regular font-size2 color-subtext mb-1'>Buy/Sell</div>
                                                                            <BzToggleButton
                                                                                wrapperClassName='buysell-wrap'
                                                                                leftButtonClassName={`btn btn-sm ${element?.activeButtonToggleIndex === 0 ? 'btn-positive' : ''} `}
                                                                                rightButtonClassName={`btn btn-sm ${element?.activeButtonToggleIndex === 1 ? 'btn-negative' : ''} `}
                                                                                leftButtonTitle="BUY" rightButtonTitle="SELL" activeButtonToggleIndex={element?.activeButtonToggleIndex}
                                                                                setActiveButtonToggleIndex={(e) => {
                                                                                    handleDropdownChange({ target: { name: "activeButtonToggleIndex", value: e === 0 ? "BUY" : "SELL" }, }, i);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col md={6} className='flex-column align-items-start'>
                                                                        <div className='font-regular font-size3 color-subtext mb-1'>Order Type</div>
                                                                        <div className='Bzmodalselect-dropdown'>
                                                                            <BzDropdown>
                                                                                <Dropdown.Toggle className='btn-default'>{element?.orderType}</Dropdown.Toggle>
                                                                                <Dropdown.Menu>
                                                                                    <Dropdown.Item onClick={() => handleDropdownChange({ target: { value: "RL-MKT", name: 'orderType' } }, i)}>
                                                                                        RL-MKT
                                                                                    </Dropdown.Item>
                                                                                    <Dropdown.Item onClick={() => handleDropdownChange({ target: { value: "RL", name: 'orderType' } }, i)}>
                                                                                        RL
                                                                                    </Dropdown.Item>
                                                                                </Dropdown.Menu>
                                                                            </BzDropdown>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row className='mb-2'>
                                                                    <Col md={6} className='flex-column align-items-start'>
                                                                        <div className='font-regular font-size3 color-subtext mb-1'>Lots</div>
                                                                        <div className='input-group position-relative'>
                                                                            <div className='icon-12 icon-order-decrease input-number-left-wrap' id={'qtySub' + i} onClick={() => { onHandleClick('qtySub', i); }}></div>
                                                                            <BzInputText
                                                                                size='sm'
                                                                                maxLength={8}
                                                                                type='text'
                                                                                autoFocus={i === 0}
                                                                                className='font-regular text-center'
                                                                                name="count"
                                                                                onBlur={(e) => { handleBlur(e, 'count', i); }}
                                                                                onChange={(e) => handleChange(e, "count", i)}
                                                                                value={element?.count}
                                                                                onKeyDown={(e) => { onHandleClick('qty', i, e); }}
                                                                            />
                                                                            <div className='icon-12 icon-order-increase input-number-right-wrap' id={'qtyAdd' + i} onClick={() => { onHandleClick("qtyAdd", i); }}></div>
                                                                        </div>
                                                                        <div className='font-medium font-size1 color-subtext mt-2'>1 Lot = {element?.ask_qty} Qty</div>
                                                                    </Col>
                                                                    <Col md={6} className='flex-column align-items-start'>
                                                                        <div className='d-flex align-items-center justify-content-between mb-1'>
                                                                            <div className='font-regular font-size3 color-subtext'>Price</div>
                                                                            <div className='icon-20 icon-marketdepth ms-3' onClick={() => { onhandleMarketDepth(element?.extraInfo, i, element?.instrument); }}></div>
                                                                        </div>
                                                                        <div className='input-group position-relative'>
                                                                            <div className='icon-12 icon-order-decrease input-number-left-wrap' onClick={() => {
                                                                                if (element?.orderType !== 'RL-MKT') {
                                                                                    onHandleClick("priceSub", i);
                                                                                }
                                                                            }}>
                                                                            </div>
                                                                            <BzInputText
                                                                                size='sm' maxLength={10} type='text' disabled={element?.orderType === "RL-MKT"}
                                                                                className='font-regular text-center' name="legPrice"
                                                                                value={element?.orderType === 'RL-MKT' ? element?.ltp : element?.legPrice} onBlur={(e) => { handleBlur(e, 'legPrice', i); }}
                                                                                onChange={(e) => handleChange(e, "legPrice", i)}
                                                                                onKeyDown={(e) => { handleLegPricekeyDown(e, 'price', i, e.key); }}
                                                                            />
                                                                            <div className='icon-12 icon-order-increase input-number-right-wrap' onClick={() => {
                                                                                if (element?.orderType !== 'RL-MKT') {
                                                                                    onHandleClick("priceAdd", i);
                                                                                }
                                                                            }}>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                            :
                                                            null
                                                    }
                                                </div>
                                            )
                                        }
                                        <Row className='g-0 mb-2'>
                                            <Col md={12}>
                                                <div className='font-regular font-size2 color-subtext mb-1'>Validity: <span className='color-text'>IOC</span></div>
                                            </Col>
                                        </Row>
                                        <Row className='g-0 mb-2'>
                                            <Col md='auto'>
                                                <BzButton type='button' className='btn btn-sm btn-primary d-flex align-items-center' onClick={() => { setSelectedLegToUpdate(null); handleOpenAddleg(MULTI_LEG.ADD_NEW_LEG); }} disabled={legInfo?.length === MULTI_LEG.ORDER_MAX_LEGS}>
                                                    <div className='icon-12 icon-add-circle-fill icon-light me-2'></div>
                                                    Add Leg
                                                </BzButton>
                                            </Col>
                                        </Row>
                                        {
                                            isShowMarketDepth !== null ?
                                                <>
                                                    <Row className='g-0 bdr-top px-2 py-2'>
                                                        <Row className='g-0'>
                                                            <Col md={12} className='d-flex justify-content-start align-items-center'>
                                                                <Button
                                                                    className={marketDepthActiveTab === "MarketDepth" ? 'btn btn-sm btn-primary btn-rounded me-2' : 'btn btn-sm btn-default btn-rounded me-2'}
                                                                    onClick={() => setMarketDepthActiveTab('MarketDepth')}
                                                                >
                                                                    Market Depth
                                                                </Button>
                                                                <Button
                                                                    className={marketDepthActiveTab === "supportResistance" ? 'btn btn-sm btn-primary btn-rounded' : 'btn btn-sm btn-default btn-rounded'}
                                                                    onClick={() => setMarketDepthActiveTab('supportResistance')}
                                                                >
                                                                    Support/Resistance
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                        {
                                                            marketDepthActiveTab === "MarketDepth" ?
                                                                <AllExchangesMarketDepth onValueClick={e => handlePriceOnMktDepthClick(e)} layoutType={layoutType} heading={false} />
                                                                :
                                                                marketDepthActiveTab === "supportResistance" ?
                                                                    <SupportResistance supportResistance={supportResistance} strViewFrom={SUPPORT_RESISTANCE_VIEW.ORDER_ENTRY} layoutType={layoutType} />
                                                                    :
                                                                    null
                                                        }
                                                    </Row>
                                                </>
                                                :
                                                null
                                        }
                                    </>
                                    :
                                    null
                            }
                            {
                                modals['ADD_LEG_MODAL'] ?
                                    <AddLegMultiscriptModal
                                        legData={{ data: multiLegData.length ? multiLegData[0]?.extraInfo : scripInfo, legNumber: selectedLegToUpdate }}
                                        setThirdLegData={(data) => { handleAddExtraLeg({ ...data }); }} updateLegData={updateLegHandler}
                                        arrRowSelection={legDataForChildComps}
                                    />
                                    :
                                    null
                            }
                        </Container>
                    </div>
                    :
                    null
            )
    );
});

export default memo(MultiLeg);
// Parshva S - 15/11/2023 BT-102679 - Breeze- Multi Leg order entry - end